'use strict';

angular
  .module('AdminSupervisorReviewControllers')

  .controller('AdminSupervisorAccessReviewController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    'systemsAndSysRoles',
    'accessReview',
    'authenticatedUser',
    function ($scope, $state, $translate, topBar, systemsAndSysRoles, accessReview, authenticatedUser) {
      $translate('iam.admin.supervisorReview.pageTitle', { name: accessReview.Name }).then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-eye');
      });

      //const
      var NOT_STARTED = 'Not Started';
      var IN_PROGRESS = 'In Progress';
      var ADDITIONAL_REV = 'Additional Review';
      var COMPLETE = 'Complete';

      //properties
      $scope.lastUpdate = null;
      $scope.searchSystemStatus = null;
      $scope.search = null;
      $scope.currAccessReview = null;

      //services
      $scope.systemsAndSysRoles = systemsAndSysRoles;
      $scope.accessReview = accessReview;
      $scope.currentUserIdentity = authenticatedUser.IdentityName;

      //filters : lodash
      $scope.nbNotStarted = _.filter(systemsAndSysRoles, { Status: NOT_STARTED }).length;
      $scope.nbInProgress = _.filter(systemsAndSysRoles, { Status: IN_PROGRESS }).length;
      $scope.nbCompleted = _.filter(systemsAndSysRoles, { Status: COMPLETE }).length;
      $scope.nbAdditionalReview = _.filter(systemsAndSysRoles, { Status: ADDITIONAL_REV }).length;

      $scope.$watch(
        function ($scope) {
          return $scope.systemsAndSysRoles.map(function (obj) {
            return obj.Status;
          });
        },
        function (updatedSystemsAndSysRoles) {
          $scope.systemsAndSysRolesStatus = _.uniq(updatedSystemsAndSysRoles);
        },
        true
      );

      $scope.currentAccessReview = function () {
        if (!_.isEmpty($scope.accessReview)) $scope.currAccessReview = $scope.accessReview.Name;
        else
          $translate('iam.admin.supervisorReview.messages.reviewClosed').then(function (translation) {
            $scope.currAccessReview = translation;
          });
      };

      $scope.lastUpdateTimeAgo = function (lastUpdt) {
        if (!_.isUndefined(lastUpdt)) return true;
        return false;
      };

      $scope.resetFilter = function () {
        $scope.searchSystemStatus = null;
        $scope.search = null;
      };

      $scope.changeSearchStatus = function (systemStatus) {
        $scope.searchSystemStatus = systemStatus;
      };

      $scope.isStatusActive = function (status) {
        if (_.isUndefined(status)) return false;
        return status === $scope.searchSystemStatus;
      };

      $scope.labelStatus = function (status) {
        if (status == NOT_STARTED) return 'label label-gray';

        if (status == COMPLETE) return 'label label-green';

        if (status == IN_PROGRESS) return 'label label-blue';

        if (status == ADDITIONAL_REV) return 'label label-orange';
      };

      $scope.nbStatusCount = function (message) {
        if (message == NOT_STARTED) $scope.nbStatusItem = $scope.nbNotStarted;

        if (message == COMPLETE) $scope.nbStatusItem = $scope.nbCompleted;

        if (message == IN_PROGRESS) $scope.nbStatusItem = $scope.nbInProgress;

        if (message == ADDITIONAL_REV) $scope.nbStatusItem = $scope.nbAdditionalReview;
      };
    },
  ]);
